import { FormEvent, useState } from 'react';
import { BRAND } from '../../../ui/brand';
import { useAuth } from '../auth';

export function Login() {
  const { login, ended } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login(email, password);
    } catch (err) {
      setError((err as Error).message);
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <main className="login-main">
        <form className="login-card" onSubmit={submit}>
          <img className="login-logo" src={BRAND.logoWide} alt={BRAND.name} width={331} height={92} />
          <h1 className="login-title">Sprout <span className="login-badge">Staff</span></h1>
          <p className="login-sub">Vehicles, trackers, customers and installs.</p>
          <label htmlFor="email">Email</label>
          <input id="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
          <label htmlFor="password">Password</label>
          <input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          {ended && !error && <p className="notice" role="status">Your session has ended. Please log in again.</p>}
          {error && <p className="error" role="alert">{error}</p>}
          <button type="submit" className="primary" disabled={busy}>{busy ? 'Logging in…' : 'Log in'}</button>
        </form>
        <p className="login-foot">Customers log in at the Fleet Functions app.</p>
      </main>
      <footer className="login-brand">{BRAND.name} · {BRAND.tagline}</footer>
    </div>
  );
}
